import React, {Component} from "react";
import {Card, CardBody, Button, Modal, Row, Col, Container, FormGroup} from "reactstrap";
import pricingData from "./../views/pricingXaregrowth/pricingData";
import "../views/pricingXaregrowth/Pricing.css";
import {FaCheckCircle, FaTimesCircle} from "react-icons/fa";
import UtilService from "../services/utilService";
import NotificationAlert from "react-notification-alert";
import Loader from "./../views/Loader";
import Login from "./../views/pages/auth/Login";
import FormInput from "../components/common/form/FormInput";
import FormReactSelect from "../components/common/form/FormReactSelect";
import countries from "../util/countriesGlobal";
import _ from "lodash";
import CompanyService from "../services/companyService";
import ContactUsService from "../services/contactUsService";

class Contactus extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectKey: UtilService.uuidv4(),
            planSubscriptionModal: false,
            showChart: this.props.showChart || "block",
            loading: false,
            errorObj: {},
            name: "",
            email: "",
            country: "",
            comments: "",
            selectedPlan: {},
            selectedCountry: {},


        };
        this.onChange = this.onChange.bind(this);
        this.notify = this.notify.bind(this);
    }

    componentDidMount() {
    }

    clearPricingSubscriptionData = () => {
        this.setState({
            name: "",
            country: "",
            email: "",
            comments: "",
            selectedPlan : {},
            selectedCountry: {},
        })
    }

    onChange(event) {
        this.setState({[event.target.name]: event.target.value});
        console.log(this.state);
    }

    handleCountrySelectChange = (valueObj) => {
        if (_.isNull(valueObj)) {
            this.setState({selectedCountry: {}, country: ""});
        } else {
            this.setState({selectedCountry: valueObj, country: valueObj.key});
        }
    }





    toggleModal = state => {
        this.setState({
            [state]: !this.state[state]
        });
    };


    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };

    submitQuery = () => {
        console.log(this.state);
        this.setState({loading: true});
        const data = {
            name: this.state.name,
            country: this.state.country,
            email: this.state.email,
            comments: this.state.comments,
            plan: "IGNORE"
        }
        ContactUsService.contactUsPartner(data).then(response => {
            console.log(response.data);
            if (response.responseStatus === "SUCCESS") {
                this.notify(
                    response.responseStatus.toLowerCase(),
                    response.responseStatus,
                    response.message
                );
                this.clearPricingSubscriptionData();
                this.setState({loading: false});
                this.toggleModal("contactUsModal");
            } else {
                this.setState({errorObj: response.data});
                console.error("Error    ==>     " + response.message);
                this.setState({loading: false});
            }
        });

    }

    render() {
        return (
            <>
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert"/>
                </div>
                {this.state.loading && <Loader/>}
                {/*<div className="pricing-container">
                    {pricingData.map((plan, index) => (
                        <Card key={index} className={`pricing-card ${index === 2 ? "highlight" : ""}`}>
                            {plan.popular && (
                                <span className="popular-badge">Most Purchased</span>
                            )}
                            <CardBody>
                                <h2 className="plan-title">{plan.title}</h2>
                                <h3 className="plan-price">{plan.price}</h3>
                                <br/>
                                <ul className="features-list list-unstyled ">
                                    {plan.features.map((feature, idx) => (
                                        <li key={idx} className={`mb-2 ${feature.value ? "included" : "excluded"}`} style={{textAlign:  "start"}}>
                                            {feature.value ? (
                                                <FaCheckCircle className="text-success me-4"/>
                                            ) : (
                                                <FaTimesCircle className="text-danger me-4"/>
                                            )} &nbsp;&nbsp;
                                            {feature.label}
                                            {typeof  feature.value === "number" ? <b> ({feature.value}) </b> : null }
                                        </li>
                                    ))}
                                </ul>
                                <Button className="pricing-btn" color={index === 2 ? "success" : "default"}
                                        onClick={(event) => this.handlePlanSelect(event, plan)}>
                                    {plan.price === "Contact Us" ? "Contact Sales" : "Subscribe"}
                                </Button>
                            </CardBody>
                        </Card>
                    ))}
                </div>*/}

                <Container fluid style={{display: this.props.display || 'block'}}>
                    <Row className="justify-content-center" style={{display: this.state.showChart}}>
                        <Col xs={12} md={12} lg={12}>
                            <img
                                alt="XareGrowthPricing"
                                className="img-fluid"  // Makes the image scale properly
                                style={{ paddingLeft: "15%",
                                paddingRight: "15%",
                                    objectFit: "contain",
                                width: "100%%",
                                maxWidth:"100%"}}
                                src={require("assets/img/brand/pricing.png")}
                            />
                        </Col>
                    </Row>
                    <br style={{display: this.state.showChart}}/>
                    <br style={{display: this.state.showChart}}/>
                    <br style={{display: this.state.showChart}}/>
                    <Row className="align-items-center justify-content-center">
                        <Col xs="auto">
                            <Button
                                className="custom-danger-outline"
                                style={{marginLeft:"16px"}}
                                outline onClick={(event) => this.setState({contactUsModal:true})}>
                                Contact Us
                            </Button>
                            <br/>

                        </Col>
                    </Row>


                </Container>

                <Modal
                    // size={"lg"}
                    className="modal-dialog-centered"
                    isOpen={this.state.contactUsModal}
                    toggle={() => this.toggleModal("contactUsModal")}
                >

                    <div className="modal-header">
                        <h3 className="modal-title" id="planSubscriptionModalLabel">
                            Please provide your details to reach back to you.
                        </h3>
                        <button
                            aria-label="Close"
                            className="close"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => this.toggleModal("contactUsModal")}
                        >
                            <span aria-hidden={true}>×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <Row>
                            <Col md="12">
                                <FormInput
                                    name="name"
                                    className="form-control-label"
                                    id="name"
                                    placeholder="Name"
                                    type="text"
                                    onChange={this.onChange}
                                    label="Name"
                                    value={this.state.name || ""}
                                    errorMsg={this.state.errorObj?.name || ""}
                                    required
                                />
                            </Col>
                            <Col md="12">
                                <FormInput
                                    name="email"
                                    className="form-control-label"
                                    id="email"
                                    placeholder="Email address"
                                    type="text"
                                    onChange={this.onChange}
                                    label="Email Address"
                                    value={this.state.email || ""}
                                    errorMsg={this.state.errorObj?.email || ""}
                                    required
                                />
                            </Col>
                            <Col md="12">
                                <FormGroup>
                                    <FormReactSelect
                                        selectKey={this.state.selectKey}
                                        isMulti={false}
                                        className="form-control-label"
                                        isSearchable={true}
                                        label="Select Country"
                                        name={"country"}
                                        onChange={this.handleCountrySelectChange}
                                        optionValue={"value"}
                                        defaultValue={this.state.selectedCountry}
                                        optionList={countries}
                                        optionLabel={"key"}
                                        placeHolder="Select Country"
                                        errorMsg={this.state?.errorObj?.country || ""}
                                        required
                                    />
                                </FormGroup>
                            </Col>

                            <Col md="12">
                                <FormInput
                                    name="comments"
                                    className="form-control-label"
                                    id="comments"
                                    placeholder="Additional Comments"
                                    type="textarea"
                                    onChange={this.onChange}
                                    label="Comments"
                                    value={this.state.comments || ""}
                                    errorMsg={this.state.errorObj?.comments || ""}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md="4"></Col>
                            <Col md="4">
                                <Button color="default" type="button" outline onClick={() => this.submitQuery()}>
                                    Apply
                                </Button>
                            </Col>
                            <Col md="4"></Col>
                        </Row>

                    </div>


                </Modal>
            </>
        );
    }
}

export default Contactus;
